import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"

import { signIn, signOut } from "@aws-amplify/auth"

const SSOCloudBeauty: React.FC = () => {
	const [searchParams] = useSearchParams()
	const [error, setError] = useState<string | null>(null)
	const loginToken = searchParams.get("login_token")

	useEffect(() => {
		const consumeToken = async () => {
			if (!loginToken) {
				setError("ログイントークンが指定されていません")
				return
			}
			try {
				const response = await fetch(
					`${process.env.REACT_APP_IDP_SSO_PUBLIC_API_URL}/go.idp.sso.public.v1.IdpSSOPublicService/ConsumeCloudBeautyLoginToken`,
					{
						method: "POST",
						headers: {
							"Content-Type": "application/json",
						},
						body: JSON.stringify({
							loginToken: loginToken,
						}),
					}
				)

				if (!response.ok) {
					throw new Error(`API request failed with status ${response.status}`)
				}

				const data = await response.json()

				if (data.userId && data.password && data.salonId) {
					await signOut().catch((error) => {
						console.error("signOut failed:", error)
					})

					await signIn({
						username: data.userId,
						password: data.password,
					}).catch((error) => {
						if (
							error instanceof Error &&
							error.name !== "UserAlreadyAuthenticatedException"
						) {
							console.error("Cognito sign-in failed:", error)
							throw new Error("認証に失敗しました")
						}
					})
					const encodedSid = btoa(data.salonId.toString())
					window.location.href = `/?sid=${encodedSid}`
				} else {
					throw new Error("Invalid response format")
				}
			} catch (error) {
				console.error("SSO token consumption error:", error)
				setError(
					"認証処理中にエラーが発生しました。もう一度POS画面をリロードして最初からやり直してください"
				)
			}
		}

		consumeToken()
	}, [loginToken])

	if (error) {
		return (
			<div
				style={{
					padding: "20px",
					textAlign: "center",
					fontFamily: "Arial, sans-serif",
				}}
			>
				<h2>認証エラー</h2>
				<p>{error}</p>
			</div>
		)
	}

	return (
		<div
			style={{
				padding: "20px",
				textAlign: "center",
				fontFamily: "Arial, sans-serif",
			}}
		>
			<h2>認証中...</h2>
			<p>しばらくお待ちください</p>
		</div>
	)
}

export default SSOCloudBeauty
